export const hasProcedureInitialView = (node) => {
    if (!node || typeof node !== 'object') {
        return false;
    }

    const initialView = node.initial_view;
    if (!initialView || typeof initialView !== 'object') {
        return false;
    }

    const hasPanoramaView = ['yaw', 'pitch', 'zoom'].every((key) => initialView?.[key] != null);
    const hasOrbitView = ['init_view_flat_x', 'init_view_flat_y', 'zoom'].every(
        (key) => initialView?.[key] != null
    );

    return hasPanoramaView || hasOrbitView;
};

export const buildProcedureInitialViewAction = (node) => {
    if (!hasProcedureInitialView(node)) {
        return null;
    }

    return {
        id: node.id,
        zone_id: node.zone_id,
        asset_id: node.asset_id,
        item_id: node.item_id,
        initial_view: node.initial_view,
        ...node,
    };
};
